import { render, staticRenderFns } from "./UserPanel.vue?vue&type=template&id=186635d7&scoped=true"
import script from "./UserPanel.vue?vue&type=script&lang=js"
export * from "./UserPanel.vue?vue&type=script&lang=js"
import style0 from "./UserPanel.vue?vue&type=style&index=0&id=186635d7&prod&lang=css"
import style1 from "./UserPanel.vue?vue&type=style&index=1&id=186635d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186635d7",
  null
  
)

export default component.exports